import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { About } from "../src/landingPage/views/About/About";
import { meta } from "../src/landingPage/datasets/meta";

const AboutUsPage = () => {
  return (
    <>
      <NextHead
        currentPath="/about-us"
        title={meta.about.title}
        description={meta.about.description}
      />
      <About />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default AboutUsPage;
